/**
 * What is Business Web's own on the shared account screens (@tonnie/account):
 * its brand panel, its language picker, its in-app terms page, and where a
 * finished sign-in or sign-up goes — the team invitation being accepted
 * (AcceptInvitePage stashed its token), else the dashboard (sign-in) or
 * onboarding (sign-up). Mounted once in App.tsx.
 */
import type { AccountPortalConfig } from '@tonnie/account';

import { LanguageSelector } from '@/components/ui/LanguageSelector';
import { featureFlags } from '@/core/config/feature-flags';

function pendingInvitationPath(): string | null {
  const token = sessionStorage.getItem('tonnie_pending_invitation');
  return token ? `/accept-invite?token=${encodeURIComponent(token)}` : null;
}

export const BUSINESS_ACCOUNT_PORTAL: AccountPortalConfig = {
  portal: 'business',
  languageSelector: <LanguageSelector showLabel />,
  afterSignIn: () => pendingInvitationPath() ?? '/dashboard',
  afterSignUp: () => pendingInvitationPath() ?? '/onboarding',
  legal: { terms: '/terms-privacy', privacy: '/terms-privacy' },
  securitySettingsPath: '/settings?business.section=security',
  allowTotp: featureFlags.ENABLE_2FA,
};
